import { useMutation } from 'react-query';
import { 
  login,
} from 'api/login';

export const useLogin = () => {

  return useMutation((params: {username: string, password: string}) => login(params));

}